
export class AddUserModel {
    optimistic: any = 0;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    type = 'ENDUSER';
    class = 'API::CompanyEmployee';
}

